import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { IFilterProyectoModel } from 'src/app/models/interfaces/proyectos/IFilterProyectoModel';
import { IProyectoModel } from 'src/app/models/interfaces/proyectos/IProyectoModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ProyectoService {

  private configUrl = [environment.apiGatewayUrl, 'proyectos'].join('/');
  constructor(private http: HttpClient) { }

  getListFiltered(
    model: IFilterProyectoModel
    ) : Observable<SearchResultModel<IProyectoModel[]>> {
    let queryParams: string[] = new Array<string>();

    queryParams.push(`page=${model.page}`);
    queryParams.push(`take=${model.pageSize}`);
    queryParams.push(`idEstado=${model.idEstado}`);
    
    if (model.proyecto !== '') {
      queryParams.push(`proyecto=${model.proyecto}`);
    }

    return this.http.get<SearchResultModel<IProyectoModel[]>>(
      `${this.configUrl}/filtrar?${queryParams.join('&')}`
    );
  }

  getAllList(
    model: IFilterProyectoModel
    ) : Observable<IProyectoModel[]> {
    let queryParams: string[] = new Array<string>();

    // queryParams.push(`page=${model.page}`);
    // queryParams.push(`take=${model.pageSize}`);

    return this.http.get<IProyectoModel[]>(
      `${this.configUrl}/all?${queryParams.join('&')}`
    );
  }

  getById(id: number): Observable<IProyectoModel> {
    return this.http.get<IProyectoModel>(`${this.configUrl}/${id}`);
  }

  submit(model: IProyectoModel) {
    return this.http.post<IProyectoModel>(`${this.configUrl}`, model);
  }

  update(model: IProyectoModel) {
    return this.http.put<IProyectoModel>(
      `${this.configUrl}/${model.idProyecto}`,
      model
    );
  }

  delete(id: number) {
    return this.http.delete<IProyectoModel>(`${this.configUrl}/${id}`);
  }
}
